// shared/state/ducks/themeState.ts
import { Reducer } from 'redux';
import { Selector } from 'shared/state';
import { HarmonyTheme } from '@uhg-harmony/foundations';
import { ThemeType } from 'shared/util/ThemeType';

export interface ThemeState {
  themeType: ThemeType;
  theme: HarmonyTheme | Theme | null;
}

const defaultState: ThemeState = {
  themeType: ThemeType.Optum,
  theme: null, // initially null
};

export const SET_THEME_TYPE = 'duplo/theme/SET_THEME_TYPE';
export const SET_THEME = 'duplo/theme/SET_THEME';

const reducer: Reducer<ThemeState> = (state = defaultState, action) => {
  switch (action.type) {
    case SET_THEME_TYPE:
      return { ...state, themeType: action.themeType };
    case SET_THEME:
      return { ...state, theme: action.theme ?? null };
    default:
      return state;
  }
};

export default reducer;

// Actions
export const setThemeType = (themeType: ThemeType) => ({
  type: SET_THEME_TYPE,
  themeType,
});

export const setTheme = (theme: HarmonyTheme | Theme | null) => ({
  type: SET_THEME,
  theme,
});

// Selectors
const selectSlice: Selector<ThemeState> = () => state => state.themeState;

export const selectThemeType: Selector<ThemeType> = () => state =>
  selectSlice()(state).themeType;

export const selectTheme: Selector<HarmonyTheme | Theme | null> = () => state =>
  selectSlice()(state).theme;
